(function () {
  if (window.MysticProductMediaVariantSync) return;
  window.MysticProductMediaVariantSync = true;

  var MEDIA_SELECTOR = 'product-media-carousel';
  var MEDIA_CAROUSEL_SELECTOR = '[data-product-media-carousel-component]';
  var MODAL_CAROUSEL_SELECTOR = '[data-product-modal-carousel]';
  var OPTION_GROUP_SELECTOR = '[data-variant-picker-option-inputs]';
  var initialized = new WeakSet();
  var modalCloseObservers = new WeakSet();
  var pendingModalSlides = new WeakMap();
  var syncing = false;

  function findPickerBySectionId(sectionId) {
    if (!sectionId) return null;

    return Array.prototype.find.call(
      document.querySelectorAll('variant-picker.product-variant-picker'),
      function (picker) {
        return picker.getAttribute('data-section') === sectionId;
      }
    );
  }

  function getVariantPicker(element) {
    var sectionHost = element.closest('[data-section-id]');
    var scopedPicker = findPickerBySectionId(
      sectionHost && sectionHost.getAttribute('data-section-id')
    );

    if (scopedPicker) return scopedPicker;

    var root =
      element.closest('.product__content') ||
      element.closest('.shopify-section') ||
      document;

    return root.querySelector('variant-picker.product-variant-picker');
  }

  function getActiveSlideFromCarousel(carousel, slideSelector) {
    if (!carousel) return null;

    if (carousel.embla && typeof carousel.embla.selectedScrollSnap === 'function') {
      var nodes = carousel.embla.slideNodes && carousel.embla.slideNodes();
      return nodes && nodes[carousel.embla.selectedScrollSnap()];
    }

    var viewport = carousel.querySelector('[data-carousel-viewport]');
    var slides = Array.prototype.slice.call(carousel.querySelectorAll(slideSelector));

    if (!viewport || !slides.length) return slides[0] || null;

    var viewportRect = viewport.getBoundingClientRect();
    var viewportCenter = viewportRect.left + viewportRect.width / 2;

    return slides.reduce(function (closest, slide) {
      var slideRect = slide.getBoundingClientRect();
      var slideCenter = slideRect.left + slideRect.width / 2;
      var distance = Math.abs(slideCenter - viewportCenter);

      if (!closest || distance < closest.distance) {
        return { slide: slide, distance: distance };
      }

      return closest;
    }, null).slide;
  }

  function chooseFirstOption(slide) {
    if (!slide || syncing) return;

    var firstOption = slide.getAttribute('data-variant-first-option');
    if (!firstOption) return;

    var picker = getVariantPicker(slide);
    if (!picker) return;

    var firstOptionGroup = picker.querySelector(OPTION_GROUP_SELECTOR);
    if (!firstOptionGroup) return;

    var matchingInput = Array.prototype.find.call(
      firstOptionGroup.querySelectorAll('input[type="radio"]'),
      function (input) {
        return input.value === firstOption;
      }
    );

    if (!matchingInput || matchingInput.checked) return;

    syncing = true;
    matchingInput.checked = true;
    matchingInput.dispatchEvent(new Event('change', { bubbles: true }));

    window.setTimeout(function () {
      syncing = false;
    }, 700);
  }

  function bindModalClose(modal) {
    if (!modal || modalCloseObservers.has(modal)) return;

    modalCloseObservers.add(modal);

    new MutationObserver(function () {
      if (modal.classList.contains('is-opened')) return;

      var pendingSlide = pendingModalSlides.get(modal);
      if (!pendingSlide) return;

      pendingModalSlides.delete(modal);

      window.requestAnimationFrame(function () {
        chooseFirstOption(pendingSlide);
      });
    }).observe(modal, { attributes: true, attributeFilter: ['class'] });
  }

  function bindCarousel(carousel, slideSelector, options) {
    if (!carousel || initialized.has(carousel)) return;

    initialized.add(carousel);

    var modal = options && options.applyOnModalClose
      ? carousel.closest('product-modal')
      : null;

    if (modal) bindModalClose(modal);

    var syncActiveSlide = function () {
      window.requestAnimationFrame(function () {
        var activeSlide = getActiveSlideFromCarousel(carousel, slideSelector);

        if (modal) {
          pendingModalSlides.set(modal, activeSlide);
          return;
        }

        chooseFirstOption(activeSlide);
      });
    };

    var bindEmbla = function (attemptsLeft) {
      if (carousel.embla && typeof carousel.embla.on === 'function') {
        carousel.embla.on('select', syncActiveSlide);
        return;
      }

      if (attemptsLeft > 0) {
        window.setTimeout(function () {
          bindEmbla(attemptsLeft - 1);
        }, 100);
      }
    };

    bindEmbla(20);

    carousel.addEventListener('click', function () {
      window.setTimeout(syncActiveSlide, 50);
    });

    carousel.addEventListener(
      'touchend',
      function () {
        window.setTimeout(syncActiveSlide, 80);
      },
      { passive: true }
    );

    carousel.addEventListener('keyup', function (event) {
      if (event.key === 'Enter' || event.key === ' ') {
        window.setTimeout(syncActiveSlide, 50);
      }
    });
  }

  function bindMedia(media) {
    bindCarousel(media.querySelector(MEDIA_CAROUSEL_SELECTOR), '.carousel__slide[data-media-id]');
  }

  function init(root) {
    Array.prototype.forEach.call(
      (root || document).querySelectorAll(MEDIA_SELECTOR),
      bindMedia
    );

    Array.prototype.forEach.call(
      (root || document).querySelectorAll(MODAL_CAROUSEL_SELECTOR),
      function (carousel) {
        bindCarousel(carousel, '[data-product-modal-slide]', { applyOnModalClose: true });
      }
    );
  }

  document.addEventListener('DOMContentLoaded', function () {
    init(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });

  var mutationFrame = null;

  new MutationObserver(function () {
    if (mutationFrame) return;

    mutationFrame = window.requestAnimationFrame(function () {
      mutationFrame = null;
      init(document);
    });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
